export enum VerifyAccountStep {
  Otp = 'otp',
  MobileNumberUpdateSubmitted = 'mobile_number_update_submitted'
}

export interface UpdateMobileNumberRequest {
  countryCode: string;
  mobileNumber: string;
}
